import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { AbstractView } from '@core/interfaces/abstract-view';
import { DialogTermConditionPresenter } from './dialog-term-condition.presenter';
import { DialogTermConditionViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ButtonActionComponent } from '@shared/.';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ScreenLoadingComponent } from '@shared/components/screen-loading/screen-loading.component';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-dialog-term-condition',
  standalone: true,
  imports: [
    SharedModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    SkeletonModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    ButtonActionComponent,
    ConfirmationDialogComponent,
    CheckboxModule,
    ScreenLoadingComponent
  ],
  providers: [
    ConfirmationService,
    DialogTermConditionPresenter
  ],
  templateUrl: './dialog-term-condition.component.html',
  styleUrl: './dialog-term-condition.component.scss',
})
export class DialogTermConditionComponent
  extends AbstractView<DialogTermConditionPresenter>
  implements DialogTermConditionViewPresenter, OnInit, OnDestroy
{
  dialogVisible = this.presenter.dialogVisible;
  readAndAgreeTerms = this.presenter.readAndAgreeTerms;
  readAndMarketingAgreement = this.presenter.readAndMarketingAgreement;
  previewDialog = this.presenter.previewDialog;
  loading$ = this.presenter.loading$;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: DialogTermConditionPresenter,
  ) {
    super(messageService, router, store, presenter);
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }
  
  ngOnDestroy(): void {
    this.presenter.onDestroy();
  }

  hasAcceptTermAndConditions(): boolean {
    return this.presenter.hasAcceptTermAndConditions();
  }

  toggleDialog(event = true, previewDialog = false): void {
    this.presenter.toggleDialog(event, previewDialog);
  }

  onSubmit(): void {
    this.presenter.onSubmit();
  }
}
